import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const VERDE = "#0e6b6b"; // mismo verde azulado de la franja del comprobante en PDF

// Marco con aspecto de comprobante impreso: franja de título con N° y fecha y el cuerpo.
export function ComprobanteMarco({ titulo, numero = "Se asigna al guardar", fecha, color = VERDE, children }) {
  return (
    <Box sx={{ maxWidth: 940, mx: "auto", border: "1px solid", borderColor: "divider", bgcolor: "background.paper", boxShadow: 1 }}>
      <Box sx={{ bgcolor: color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", px: 1.5, py: 0.75 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 900, letterSpacing: 1.5, textTransform: "uppercase" }}>{titulo}</Typography>
        <Box sx={{ textAlign: "right", lineHeight: 1.2 }}>
          <Typography sx={{ fontSize: 11, opacity: 0.85 }}>N° de comprobante</Typography>
          <Typography sx={{ fontSize: 12.5, fontWeight: 800 }}>{numero}</Typography>
        </Box>
        {fecha && (
          <Box sx={{ textAlign: "right", lineHeight: 1.2 }}>
            <Typography sx={{ fontSize: 11, opacity: 0.85 }}>Fecha</Typography>
            <Typography sx={{ fontSize: 12.5, fontWeight: 800 }}>{fecha}</Typography>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 1.25 }}>{children}</Box>
    </Box>
  );
}

// Título de sección dentro del comprobante (una línea con el nombre y un trazo hasta el borde).
export function TituloSeccion({ children }) {
  return (
    <Grid size={12}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 800, letterSpacing: 0.8, textTransform: "uppercase", color: VERDE, whiteSpace: "nowrap" }}>{children}</Typography>
        <Box sx={{ flex: 1, borderTop: "1px solid", borderColor: "divider" }} />
      </Box>
    </Grid>
  );
}

// Franja con los importes resultantes (se actualiza mientras se escribe).
export function ResumenImportes({ items }) {
  return (
    <Grid size={12}>
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", justifyContent: "flex-end", border: "1px dashed", borderColor: "divider", bgcolor: "action.hover", px: 1.5, py: 0.6 }}>
        {items.map(([etq, valor]) => (
          <Box key={etq} sx={{ textAlign: "right", lineHeight: 1.25 }}>
            <Typography sx={{ fontSize: 10.5, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0.5 }}>{etq}</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 900, fontVariantNumeric: "tabular-nums" }}>{valor}</Typography>
          </Box>
        ))}
      </Box>
    </Grid>
  );
}
